export const snapToRoadIcon = `
  <svg
    width="30"
    height="51"
    viewBox="0 0 30 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="1" width="22" height="22" fill="white" />
    <path
      d="M14.787 7.82422C14.178 7.82422 13.7763 7.88272 13.5449 7.94174V11.8486C13.8092 11.9076 14.1195 11.9269 14.5514 11.9269C16.1418 11.9269 17.1232 11.1215 17.1232 9.76772C17.1238 8.55023 16.2787 7.82422 14.787 7.82422Z"
      fill="#1329FE"
    />
    <path
      d="M23.8922 0H6.10659C4.53601 0 3.26367 1.27286 3.26367 2.84292V21.1576C3.26367 22.7277 4.53653 24 6.10659 24H23.8922C25.4628 24 26.7346 22.7271 26.7346 21.1576V2.84292C26.7351 1.27234 25.4628 0 23.8922 0ZM24.9833 20.7016C24.9833 21.5566 24.2907 22.2482 23.4367 22.2482H6.52966C5.67516 22.2482 4.98258 21.5556 4.98258 20.7016V3.3318C4.98258 2.47782 5.67516 1.78524 6.52966 1.78524H23.4362C24.2907 1.78524 24.9828 2.47782 24.9828 3.3318L24.9833 20.7016Z"
      fill="#1329FE"
    />
    <path
      d="M23.4353 2.87622H6.52876C6.27701 2.87622 6.07227 3.07992 6.07227 3.33219V20.702C6.07227 20.9527 6.27649 21.158 6.52876 21.158H23.4353C23.6865 21.158 23.8913 20.9533 23.8913 20.702V3.33167C23.8913 3.07992 23.6871 2.87622 23.4353 2.87622ZM18.874 12.8309C17.8539 13.7924 16.3372 14.2244 14.5697 14.2244C14.1774 14.2244 13.8416 14.2045 13.5439 14.1654V18.909H10.6017V5.84083C11.5272 5.68362 12.8142 5.56558 14.6402 5.56558C16.486 5.56558 17.7981 5.91918 18.6823 6.62638C19.5258 7.29337 20.0941 8.39335 20.0941 9.68867C20.0941 10.9856 19.6606 12.0855 18.874 12.8309Z"
      fill="#1329FE"
    />
    <path d="M11 24H19L15 28L14.3333 27.4286L11 24Z" fill="#1329FE" />
    <g filter="url(#filter0_dd)">
      <circle cx="15" cy="32" r="3" fill="white" />
      <circle cx="15" cy="32" r="2.25" stroke="#1329FE" stroke-width="1.5" />
    </g>
    <defs>
      <filter
        id="filter0_dd"
        x="0"
        y="21"
        width="30"
        height="30"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="6" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow"
          result="effect2_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
`;
